import { render, staticRenderFns } from "./infoSpace.vue?vue&type=template&id=68698c63&scoped=true"
import script from "./infoSpace.vue?vue&type=script&lang=js"
export * from "./infoSpace.vue?vue&type=script&lang=js"
import style0 from "./infoSpace.vue?vue&type=style&index=0&id=68698c63&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68698c63",
  null
  
)

export default component.exports